import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExchangeGroupCard = _resolveComponent("ExchangeGroupCard")!
  const _component_ExchangeCard = _resolveComponent("ExchangeCard")!

  return (_ctx.exchangeConfigGroups.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exchangeConfigGroups, (exchangeConfigGroup, index) => {
          return (_openBlock(), _createBlock(_component_ExchangeGroupCard, {
            key: index,
            exchangeConfigGroup: exchangeConfigGroup
          }, null, 8, ["exchangeConfigGroup"]))
        }), 128))
      ]))
    : (_ctx.exchangeConfigs.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exchangeConfigs, (exchangeConfig, index) => {
            return (_openBlock(), _createBlock(_component_ExchangeCard, {
              key: index,
              exchangeConfig: exchangeConfig
            }, null, 8, ["exchangeConfig"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
}